var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.analyticsVisible || _vm.wclVisible
    ? _c(
        "div",
        [
          _c(
            "draggable",
            {
              attrs: { "ghost-class": "ghost" },
              on: {
                end: function ($event) {
                  $event.preventDefault()
                  return _vm.onEnd()
                },
              },
              model: {
                value: _vm.layerButtons,
                callback: function ($$v) {
                  _vm.layerButtons = $$v
                },
                expression: "layerButtons",
              },
            },
            [
              _c(
                "transition-group",
                { attrs: { type: "transition", name: "flip-list" } },
                _vm._l(
                  _vm.layerButtons.filter(
                    (layer) => layer.display_name != "POI Uploads"
                  ),
                  function (element, index) {
                    return _c(
                      "b-row",
                      {
                        key: element.name,
                        staticClass: "layer-container",
                        class: _vm.highlightTopLayer(index),
                        attrs: {
                          id: element.name,
                          "no-gutters": "",
                          disabled: _vm.checkLayerDisable(
                            element.name,
                            element.zoomControl,
                            element.minZoom
                          ),
                        },
                        on: {
                          mouseover: function ($event) {
                            element.poi == true
                              ? (_vm.hoveredLayer = element.name)
                              : null
                          },
                          mouseleave: function ($event) {
                            return _vm.removePanel()
                          },
                        },
                      },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "col-sm-9 layer-content",
                            on: {
                              click: function ($event) {
                                return _vm.toggleLayer(element, $event)
                              },
                            },
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass:
                                  "capitalize cursor vert-align py-2",
                                class: _vm.getLayerColClass(index, element),
                                attrs: { id: element.name, size: "sm" },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      element.display_name
                                        ? element.display_name
                                        : element.name
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.spinnerManager.includes(element.name)
                              ? _c("b-spinner", {
                                  staticClass: "spinner-custom-position",
                                  attrs: { variant: "primary", small: "" },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "col-sm-3 center" },
                          [
                            _c("fa", {
                              staticClass: "img-fluid cursor mx-2 pb-1",
                              attrs: {
                                title: "Move Layer To Top",
                                icon: ["fas", "long-arrow-alt-up"],
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toTopOfList(
                                    element.display_name
                                      ? element.display_name
                                      : element.name
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }
                ),
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }